import {Component, effect, ElementRef, Input, OnInit, signal, ViewChild, WritableSignal} from '@angular/core';
import {environment} from "../../../../environments/environment";
import {TranslateModule} from '@ngx-translate/core';

@Component({
  selector: 'app-video-player',
  standalone: true,
  imports: [
    TranslateModule,],
  templateUrl: './video-player.component.html',
  styleUrl: './video-player.component.scss'
})
export class VideoPlayerComponent implements OnInit {
  playList = signal<string[]>([]);
  selectedVideo = signal<string|null>('');
  selectedVideoUrl = signal<string>('');
  menuOpen = signal(false);

  @ViewChild('videoPlayer') videoPlayer?: ElementRef<HTMLVideoElement>;

  @Input() tabChanged!: WritableSignal<boolean>;
  @Input() languageCode!: string;
  @Input() videos!: any;

  constructor() {
    effect(() => {
      this.tabChanged();
      this.stopVideo();
    });

  }

  ngOnInit() {
    this.playList.set(this.videos[this.languageCode]);
  }

  playVideo(videoFilename: string): void {
    this.selectedVideoUrl.set(this.videoUrl(videoFilename));

    const cleanName = this.getCleanVideoName(videoFilename);

    this.selectedVideo.set(cleanName);
    this.closeMenu();
  }

  getCleanVideoName(videoFilename: string) {
    return videoFilename
      .replace(/^\d+\s*-\s*/, '') // remove leading number + " - "
      .replace(/\.mp4$/i, ''); // remove .mp4 extension
  }

  stopVideo() {
    if (this.videoPlayer) {
      this.videoPlayer.nativeElement.pause();
      this.videoPlayer.nativeElement.currentTime = 0;
    }
  }


  private videoUrl(fileName: string): string {
    const encodedFileName = encodeURIComponent(fileName);
    return `${environment.apiUrl}/videos/support/${this.languageCode}/${encodedFileName}`
  }

  toggleMenu() {
    this.menuOpen.update(val => !val);
  }

  closeMenu() {
    this.menuOpen.set(false);
  }

  protected readonly Object = Object;
}
